export default __webpack_public_path__ + "../img/8b926ad2f2380f3e6a41e395f3d52a64.svg";